export default [
  {
    path: "home",
    name: "Home",
    component: ()=>import('./Home.vue')
  }
];
